import { SnackbarKey, useSnackbar } from "notistack";
const enum ALERT_TYPE {
  SUCCESS = "success",
  INFO = "info",
  WARNING = "warning",
  ERROR = "error",
}

interface NotificationContent {
  message: string;
  alertType: ALERT_TYPE;
}

const useNotify = () => {
  const setNotify = ({ message, alertType }: NotificationContent) => {
    const snackId: SnackbarKey = enqueueSnackbar(message, {
      variant: "customToast",
      autoHideDuration: 5000,
      alertType,
      SnackbarProps: {
        onClick: () => closeSnackbar(snackId),
      },
    });
  };

  const setNotifySuccess = (message: string) => {
    const alertType = ALERT_TYPE.SUCCESS;
    setNotify({ message, alertType });
  };

  const setNotifyInfo = (message: string) => {
    const alertType = ALERT_TYPE.INFO;
    setNotify({ message, alertType });
  };

  const setNotifyWarning = (message: string) => {
    const alertType = ALERT_TYPE.WARNING;
    setNotify({ message, alertType });
  };

  const setNotifyError = (message: string) => {
    const alertType = ALERT_TYPE.ERROR;
    setNotify({ message, alertType });
  };

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  return { setNotifySuccess, setNotifyInfo, setNotifyWarning, setNotifyError };
};

export default useNotify;
